import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { AudioPreview } from './AudioPreview';
export function Hero() {
  return <div className="relative min-h-[60vh] md:min-h-[90vh] flex flex-col items-center justify-center pt-2 pb-0 md:pb-16 overflow-hidden" data-id="element-115">
      {/* Background Ambience */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-gradient-radial from-gold-900/10 via-dark-900/50 to-dark-900 pointer-events-none opacity-40" data-id="element-116" />

      <Section className="z-10 text-center" data-id="element-117">
        {/* Product Mockup — first thing visitors see */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="relative flex justify-center mb-6 md:mb-10" data-id="element-118">
          <div className="relative group" data-id="element-119">
            <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform scale-90 group-hover:scale-100 transition-transform duration-700" data-id="element-120" />
            <div className="absolute inset-0 bg-ember-500/10 blur-2xl rounded-full transform translate-y-4" data-id="element-121" />
            <img src="https://cdn.magicpatterns.com/uploads/3shVeG5L3mAEoY2y4gJ7Tb/MS-_EBOOK.png" alt="Minerales de Sangre Ebook Cover" className="relative z-10 w-full max-w-md rounded-lg shadow-2xl shadow-black/50 transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-122" />
          </div>
        </motion.div>

        {/* Badge + Title + Subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 md:mb-8 max-w-4xl mx-auto" data-id="element-123">
          {/* eBook PDF Badge */}
          <div className="flex justify-center mb-3 md:mb-6" data-id="element-124">
            <span className="inline-block px-5 py-1.5 rounded-full bg-dark-700/80 border border-gold-500/20 text-gold-400 font-sans font-semibold text-xs tracking-[0.2em] uppercase" data-id="element-125">
              AUDIOLIBRO + EBOOK
            </span>
          </div>

          <h1 className="font-serif font-bold text-white tracking-tight uppercase text-4xl md:text-7xl mb-2 md:mb-4 leading-none" data-id="element-126">
            VENEZUELA:
          </h1>
          <p className="font-serif italic text-cream-200 text-xl md:text-3xl leading-relaxed max-w-3xl mx-auto" data-id="element-127">
            El país con más petróleo del mundo podría no necesitar petróleo.
          </p>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-xl font-sans text-cream-200/80 mb-2 md:mb-3 max-w-2xl mx-auto" style={{
        fontSize: '16px'
      }} data-id="element-128">
          Si eres venezolano, te sentirás identificado.
        </motion.h2>

        {/* Audio Preview — right after the subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-2 md:mb-4" data-id="element-129">
          <AudioPreview data-id="element-130" />
        </motion.div>

        {/* Gold divider line */}
        <div className="w-full max-w-2xl mx-auto h-[1px]" style={{
        background: 'linear-gradient(to right, transparent, #d4b84a 50%, transparent)'
      }} data-id="element-131" />
      </Section>
    </div>;
}